import { deleteLeasedEquipmentMake } from "actions/Utilities/LeasedEquipmentMake";
import { toast } from "components/toastNotification";
import React from "react";
import { useMutation } from "react-query";

export default function useDeleteMake() {
  const { mutate } = useMutation(
    (ids: number[]) => deleteLeasedEquipmentMake(ids),
    {
      onSuccess: (res: any) => {
        switch (true) {
          case res == "Success":
            toast.fire("Success", "Make Disabled Successfully", "success");
            break;
          case res.includes("Notification insert Failed"):
            toast.fire(
              "Success ",
              `Make Disabled Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res == "Operation Failed!":
            toast.fire(
              "Disabling Make failed ",
              `Server Error: ${res}`,
              "error"
            );
            break;
          case res == "Make not found":
            toast.fire("Disabling Make failed ", `Error: ${res}`, "error");
            break;
          default:
            toast.fire("Disabling Make failed", res.Message, "error");
        }
      },
      onError: (error) => {
        toast.fire("Disabling Make failed", `Error: ${error}`, "error");
      },
    }
  );

  return mutate;
}
